export type GroupReturnContext = {
  fromGroup: boolean;
  groupId?: string;
};

export function parseGroupReturnContextFromSearch(
  search: string | undefined | null
): GroupReturnContext {
  const params = new URLSearchParams(search || '');
  const fromGroup = params.get('fromGroup') === '1';
  const groupId = params.get('groupId') || undefined;
  return { fromGroup, groupId };
}

export function buildGroupReturnContextSearch(
  context?: { fromGroup?: boolean; groupId?: string }
): string {
  if (!context?.fromGroup || !context.groupId) return '';
  return `?fromGroup=1&groupId=${encodeURIComponent(context.groupId)}`;
}
